import { render, staticRenderFns } from "./RelayRawData.vue?vue&type=template&id=56ad3940&scoped=true"
import script from "./RelayRawData.vue?vue&type=script&lang=js"
export * from "./RelayRawData.vue?vue&type=script&lang=js"
import style0 from "./RelayRawData.vue?vue&type=style&index=0&id=56ad3940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ad3940",
  null
  
)

export default component.exports